import { Layout, Skeleton, Space } from 'antd';
import { FC, Suspense } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router';
import styles from './styles.module.scss';
import { MainHeader } from 'components/headers';

export const BaseLayout: FC = () => {
  const { pathname } = useLocation();

  return (
    <Skeleton loading={false}>
      <Suspense fallback={<Skeleton active loading />}>
        <Layout className={styles.main}>
          <span>
            <MainHeader />
          </span>
          <div style={{ backgroundColor: pathname === '/' ? '#fff' : '#f0f0f0' }} className={styles.content}>
            <Outlet />
          </div>
        </Layout>
      </Suspense>
    </Skeleton>
  );
};
